// Autogenerated by publish_packages.clj
const version = 'v0.20.15';

export default version;
